export const UPDATE_CONVERSION_STATE = 'UPDATE_CONVERSION_STATE'